import React from 'react'
import "../../CSS/About/ourStory.css";

type Props = {}

const OurStory = (props: Props) => {
  return (
    <div className='ourStoryDiv'>
        <h2>Our Story</h2>
        <p className='paragrafoOurStory'>Local Face Perfumes was founded by a group of perfume enthusiasts with a shared vision to <br />
            create a haven for perfume lovers seeking authentic, locally-inspired fragrances. Inspired by<br />
            the diversity and richness of cultures around the world, we set out on a journey to curate a<br />
            collection of scents that capture the essence of each region. Our aim is to bring you closer<br />
            to the heart and soul of different cultures through the art of perfumery.</p>
    </div>
  )
}

export default OurStory